import {Component, OnInit} from '@angular/core';
import {PerformanceBonusOverviewService} from '../../../shared/services/performance-bonus-overview.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-performance-bonus-overview',
  templateUrl: './performance-bonus-overview.component.html',
  styleUrls: ['./performance-bonus-overview.component.scss']
})
export class PerformanceBonusOverviewComponent implements OnInit {
  submitting = false;
  performanceBonusOverview = [];
  slab: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public performanceBonusOverviewService: PerformanceBonusOverviewService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'direct_id': [''],
      'direct_user_slab': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.performanceBonusOverview = [];
    this.performanceBonusOverviewService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.performanceBonusOverview = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.slab = data.my_slab;
        this.triggerScroll();
      } else {
        this.performanceBonusOverview = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'direct_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.direct_id : '',
      'direct_user_slab': (this.searchForm && this.searchForm.value) ? this.searchForm.value.direct_user_slab : ''
    };
    this.get(params);
  }
}
